import toast from "react-hot-toast";
import "./index.scss";
import "react-toastify/dist/ReactToastify.min.css";

const toastError = (message: string) => {
  return toast.error(message, {
    duration: 6000,
    style: {
      border: "1px solid #db5364",
      backgroundColor: "#ffdee8",
      color: "#db5364",
      fontSize: "14px",
      fontFamily: "Poppins, sans-serif",
      fontWeight: "bold",
      marginTop: "-5px",
    },
  });
};

const toastSuccess = (message: string) => {
  return toast.success(message, {
    style: {
      border: "1px solid #1D5363",
      backgroundColor: "#D9F7A2",
      color: "#1D5363",
      fontSize: "14px",
      fontFamily: "Poppins, sans-serif",
      marginTop: "-5px",
    },
  });
};
const toastWarn = (message: string) => {
  return toast(`${message} !`, {
    style: {
      border: "1px solid #a68614",
      marginTop: "-5px",
      color: "#a68614",
      backgroundColor: "#ffeeb1",
      fontSize: "14px",
      fontFamily: "Poppins, sans-serif",
    },
  });
};

export { toastError, toastWarn, toastSuccess };
